import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Typography } from "@mui/material";
import AddVehicleModel from "components/Manufacturer/VehicleDetails/AddVehicleModel";
import VehicleModel from "components/Manufacturer/Models/VehicleModel";
import DialogEditVehicleModel from "components/Manufacturer/Models/DialogEditVehicleModel";
import EnableDecebleVehicle from "components/Manufacturer/VehicleDetails/EnableDecableVehicleconform";
import { ManufacturerTableApi } from "stores/ManufacturerStore/ManufacturerApi";

class VehicleModelContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      Vehiclename: "",
      year: "",

      editfile: {
        value: null,
        error: false,
        message: "",
      },
      file: null,
      enableDisable: "",
      chargingConfirmDaialog: false,
      vehicleStatus: "",
      vehicleStatusId: "",
      manufacturer_id: "",
      vehId: "",
      thumbnail:"",
      snackbar: false,
    };
  }
  componentDidMount() {
    this.asyncDidMount();
  }
  asyncDidMount = async () => {
    await this.props.getSlectVehicleAction();
    this.props.getVehicleModelAction();
    this.props.getVehicleTypeDropdown();
  };
  handleOnChangeEditFile = (e) => {
    let editfile = {
      value: e,
    };
    if (e.size > 102400) {
      editfile["error"] = true;
      editfile["message"] = "File should be less than 1MB";
    }
    this.setState({ editfile });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleEditClose = () => {
    this.setState({ openEdit: false });
  };
  handleEditOpen = (id, modle_name, year, manufacturer_id,thumbnail) => {
    this.setState({
      openEdit: true,

      id: `${id}`,
      Vehiclename: modle_name,
      year: year,
      manufacturer_id: manufacturer_id,
      thumbnail:thumbnail
    });
  };

  handleOnChange = (e, name) => {
    if (name === "modle_name") {
      this.setState({ Vehiclename: e.target.value });
    } else if (name === "year") {
      this.setState({ year: e.target.value });
    } else if (name === "manufacturer_id") {
      this.setState({ manufacturer_id: e.target.value });
    }
  };

  handleClickSubmit = async () => {
    const { id, Vehiclename, year, manufacturer_id, editfile } = this.state;
    let formData = new FormData();
    formData.append("id", id);
    formData.append("name", Vehiclename);
    formData.append("year", year);
    formData.append("manufacturer_id", manufacturer_id);
    formData.append("file", editfile.value);
    if (editfile.value) {
      if (editfile.value.size < 102400) {
        if (formData) {
          await ManufacturerTableApi.UpdateAddVehicalModel(formData);
          await this.props.getVehicleModelAction();
           this.props.snackbarAction({
            open: true,
            message: 'vehicle model updated successfully',
            severity: "success",
        })

          this.setState({ openEdit: false });
        }
      } else {
      }
    } else {
      if (formData) {
        await ManufacturerTableApi.UpdateAddVehicalModel(formData);
        await this.props.getVehicleModelAction();
        this.setState({ openEdit: false });
      }
    }
  };

  submitVehicle = async (data) => {
    await ManufacturerTableApi.postAddVehicleModel(data);

    this.asyncDidMount();
    this.handleClickOpen();
  };

  handleOnChnageVehicle(val) {
    this.setState({ catId: val });
    this.props.getSlectVehicleAction({ id: val });
  }

  handleChargingModelClose = () => {
    this.setState({ chargingConfirmDaialog: false });
  };

  handleStatusVehicle = (id, status) => {
    this.setState({
      chargingConfirmDaialog: true,
      vehicleStatus: status,
      vehicleStatusId: id,
    });
  };

  handleEnableClickCharging = async () => {
    const status = this.state.vehicleStatus;
    const id = this.state.vehicleStatusId;

    if (status === 1) {
      await ManufacturerTableApi.VehicleManufatureEnableDisable({
        id,
        status: 0,
      });
      this.setState({ vehicleStatus: 0 });

      this.props.getVehicleModelAction();
    } else {
      await ManufacturerTableApi.VehicleManufatureEnableDisable({
        id,
        status: 1,
      });
      this.props.getVehicleModelAction();
    }

    this.setState({ chargingConfirmDaialog: false });
  };

  render() {
    const data = this.props?.vehicleModelList;

    const selectlist = this.props?.SelectVehicleListdata?.result;

    return (
      <Grid container>
        <Stack mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/manufacturer"
            >
              Manufacturer
            </Link>
            <Typography sx={{ fontSize: "14px" }} color="#0DA861">
              Add Vehicle Model
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 1 }}>
            <AddVehicleModel
              handleOnChnageVehicle={(val) => this.handleOnChnageVehicle(val)}
              data={data}
              selectlist={selectlist}
              handleStatusVehicle={this.handleStatusVehicle}
              onClickModel={this.handleClickOpen}
              onClickEdit={this.handleEditOpen}
              submitVehicle={(val) => this.submitVehicle(val)}
              loading={this.props.isloadingModel}
              vehicleModelType = { this.props.vehicleModelTypeId?.result}
            />
          </Paper>

          <VehicleModel handleClose={this.handleClose} open={this.state.open} />

          <DialogEditVehicleModel
            selectlist={selectlist}
            handleClose={this.handleEditClose}
            open={this.state.openEdit}
            modle_name={this.state.Vehiclename}
            year={this.state.year}
            editfile={this.state.editfile}
            manufacturer_id={this.state.manufacturer_id}
            handleOnChange={(e, f) => {
              this.handleOnChange(e, f);
            }}
            handleClickSubmit={this.handleClickSubmit}
            handleOnChangeEditFile={this.handleOnChangeEditFile}
            thumbnail={this.state.thumbnail}
          />

          <EnableDecebleVehicle
            open={this.state.chargingConfirmDaialog}
            handleEnable={this.handleEnableClickCharging}
            handleclose={this.handleChargingModelClose}
            vehicleStatus={this.state.vehicleStatus}
          />
        </Grid>
      </Grid>
    );
  }
}
export default VehicleModelContainer;
